import { z } from 'zod';

export const sessionDataSchema = z.object({
  idActiveQuestion: z.string().optional(),
  isActive: z.boolean(),
});
